var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("layout", [
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "col-sm-12" },
        [
          _c("table-data", {
            attrs: {
              route: _vm.url.getList,
              settings: _vm.table.settings,
              columns: _vm.table.columns,
              inlineFilters: _vm.table.filters,
              autoUpdateFilter: _vm.table.autoUpdateFilter,
              addParamsToUrl: _vm.table.addParamsToUrl,
              loadingMsg: _vm.table.loadingMsg,
              notFoundMsg: _vm.table.notFoundMsg,
              orderByTemplate: _vm.table.orderByTemplate,
              tableClass: "table-responsive-sm table-auto",
            },
            on: { "error-load": _vm.showError },
            scopedSlots: _vm._u([
              {
                key: "filters",
                fn: function ({ tableFilters, search }) {
                  return [
                    _c(
                      "form",
                      {
                        attrs: { autocomplete: "false" },
                        on: {
                          submit: function ($event) {
                            $event.preventDefault()
                          },
                          keyup: function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            )
                              return null
                            return search.apply(null, arguments)
                          },
                        },
                      },
                      [
                        _c("div", { staticClass: "row header" }, [
                          _c(
                            "div",
                            { staticClass: "col-12" },
                            [
                              _c("header-list", {
                                attrs: {
                                  title: _vm.pageTitle,
                                  placeholderSearch: _vm.searchPlaceholder,
                                  routeAddName: `${_vm.moduleCode}.${_vm.pageID}.create`,
                                  canAdd: _vm.canAdd,
                                  addTitle: _vm.addTitle,
                                },
                                model: {
                                  value: tableFilters.q,
                                  callback: function ($$v) {
                                    _vm.$set(tableFilters, "q", $$v)
                                  },
                                  expression: "tableFilters.q",
                                },
                              }),
                            ],
                            1
                          ),
                        ]),
                      ]
                    ),
                  ]
                },
              },
              {
                key: "body",
                fn: function ({ row, index, resetSearch }) {
                  return [
                    _c("td", { class: _vm.table.columns[0].class }, [
                      _vm._v(
                        "\n                            " +
                          _vm._s(_vm.columnValue(row, _vm.table.columns[0])) +
                          "\n                        "
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "td",
                      {
                        class: [
                          _vm.table.columns[1].class,
                          { "tbl-column-disabled": !row.status },
                        ],
                      },
                      [
                        _vm._v(
                          "\n                            " +
                            _vm._s(_vm.columnValue(row, _vm.table.columns[1])) +
                            "\n                        "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("td", {
                      class: _vm.table.columns[2].class,
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.columnOnOff(row, _vm.table.columns[2])
                        ),
                      },
                    }),
                    _vm._v(" "),
                    _c("td", {
                      class: _vm.table.columns[3].class,
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.columnStatus(
                            row,
                            _vm.table.columns[3],
                            ["", "fas fa-lock"],
                            (_vm.css = ["", "text-info"])
                          )
                        ),
                      },
                    }),
                    _vm._v(" "),
                    _c("td", {
                      class: _vm.table.columns[4].class,
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.columnStatus(row, _vm.table.columns[4])
                        ),
                      },
                    }),
                    _vm._v(" "),
                    _vm.checkActions
                      ? _c("column-actions", {
                          attrs: {
                            routeEdit: `${_vm.moduleCode}.${_vm.pageID}.show`,
                            canDetail: _vm.canDetail,
                            canEdit: _vm.canEdit,
                            canDelete: _vm.canDelete && !!!row.persistent,
                            row: row,
                            index: index,
                            callbackDelete: resetSearch,
                          },
                          on: { delete: _vm.onBeforeDeleteItem },
                        })
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }